import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain relative flex min-h-screen items-center justify-center overflow-hidden bg-[#0F172A] px-6">
      <div className="hero-grid absolute inset-0" />
      <div className="relative w-full max-w-md border border-white/10 bg-[#0B1222] p-10" data-testid="admin-login-card">
        <div className="flex items-center gap-2 text-white">
          <Shield size={22} className="text-[#4687FF]" fill="#4687FF" fillOpacity={0.25} />
          <span className="font-display text-lg font-extrabold tracking-tight">
            VPNReviews<span className="text-[#4687FF]">.ai</span>
          </span>
        </div>
        <h1 className="mt-6 font-display text-2xl font-black tracking-tighter text-white">Admin Login</h1>
        <p className="mt-2 text-sm text-slate-400">Sign in to manage blog posts and news.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input
            type="email"
            required
            data-testid="admin-email-input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-white/15 bg-[#0F172A] px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:border-[#4687FF] focus:outline-none"
          />
          <input
            type="password"
            required
            data-testid="admin-password-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-white/15 bg-[#0F172A] px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:border-[#4687FF] focus:outline-none"
          />
          {error && (
            <p className="text-sm font-semibold text-rose-400" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-[#4687FF] py-3.5 font-display text-sm font-bold text-white transition-colors duration-200 hover:bg-[#2563eb] disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
